import { create } from 'zustand';
import { immer } from 'zustand/middleware/immer';

export interface PipelineEvent {
  module: string;
  timestamp: number;
  type: 'status' | 'processing';
  documentId?: string;
  status?: string;
  runId?: string;
}

interface PipelineEventState {
  events: PipelineEvent[];
  maxEvents: number;

  // Actions
  addEvent: (event: PipelineEvent) => void;
  clearEvents: () => void;
  clearOldEvents: (hoursToKeep?: number) => void;
}

export const usePipelineEventStore = create<PipelineEventState>()(
  immer((set) => ({
    events: [],
    maxEvents: 1000, // Keep last 1000 events to prevent memory issues

    addEvent: (event) => {
      set((state) => {
        // Add new event
        state.events.push(event);

        // Keep only the last maxEvents
        if (state.events.length > state.maxEvents) {
          state.events = state.events.slice(-state.maxEvents);
        }
      });
    },

    clearEvents: () => {
      set((state) => {
        state.events = [];
      });
    },

    clearOldEvents: (hoursToKeep = 24) => {
      set((state) => {
        const cutoffTime = Date.now() - (hoursToKeep * 60 * 60 * 1000);
        state.events = state.events.filter(event => event.timestamp > cutoffTime);
      });
    },
  }))
);
